// extracted by mini-css-extract-plugin
export default {"trashButton":"DeleteButton_trashButton__sAIOA","trashIcon":"DeleteButton_trashIcon__ef6zc","confirm":"DeleteButton_confirm__BGEzr"};